import axios from "axios";
import { toast } from "react-toastify";


axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.timeout = 30000;
axios.defaults.responseType = "json";

axios.interceptors.response.use(null, (error) => {
  if (error.response && error.response.status === 401) {
    toast.error("Bad Credentials!!!");
  } else if (error.response && error.response.status === 403) {
    toast.error("Forbidden!!!");
  }
  return Promise.reject(error);
});
const axiosApi = axios.create();
axiosApi.defaults.headers.common["Authorization"] = `Bearer <to be set>`;

const setAuthToken = (token) => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  axiosApi.defaults.headers.common["Userip"] = getIPAddress();
};

const getIPAddress = async function () {
  const ipv4 = "127.0.0.1";
  // const ipv6 = (await publicIp.v6()) || "";
  return ipv4;
};
const getDataFromServer = async function (api, data) {
  try {
    const response = await axiosApi.post(api, data);
    if (response && response.status === 200) {
      return response.data;
    }
  } catch (ex) {
    toast.error("Network error occurred");
    console.log(ex);
    return null;
  }
  return null;
};
const downloadFile = async function (fileName) {
  return await axiosApi({
    url: process.env.REACT_APP_FILE_PATH + fileName,
    method: "GET",
    responseType: "blob",
  }).then((response) => {
    return response;
  });
};
export default {
  default: axiosApi.defaults,
  post: axiosApi.post,
  get: axiosApi.get,
  all: axios.all,
  spread: axios.spread,
  getDataFromServer,
  setAuthToken,
  getIPAddress,
  downloadFile,
};
export { axiosApi, setAuthToken };
